export default [
  {
    title: 'داشبورد',
    icon: 'ActivityIcon',
    route: { name: 'dashboard' },
    resource: 'Dashboard',
    action: 'show',
  },
]
